<template>
	 <div id="addEmailNotice" ref="addEmailNotice" v-show="addEmailNoticeShow" v-cloak class="popup">
         <div class="content" id="addEmailNoticeBox">
			<div class="title">
				{{$t('language.popup.remoteTaskPopup.addLinkTask')}}
				<div class="icon white-close dialog-close" @click="closePopup()"></div>
			</div>
            <div class="emial-notice-content">
                <tabEmail ref="tabEmail"></tabEmail>
                <div class="emial-notice-footer">
                    <button style="float:right;" @click="saveSendEmail()">{{$t('language.common.save')}}</button>
                    <button class="white-button" style="float:right;margin-right: 10px;" @click="closePopup()">{{$t('language.common.cancel')}}</button>
                </div>
            </div>
        </div>
	</div>
	
</template>


<script>
import tabEmail from "@/components/common/tabs/tabs_transfer_options/tab_email";
    export default {
        components: {
            tabEmail
        },
		data: function() {
			return {
				addEmailNoticeShow: false,
            }
        },
        mounted(){
        },
        methods:{
            closePopup() {
                this.addEmailNoticeShow = false;
            },
            saveSendEmail() {
                //创建任务时使用
                if(this.$refs.tabEmail.sendShow){
                    if(this.$refs.tabEmail.email){
                        this.$parent.checkedEmail = true;
                    }else {
                        this.$refs.tabEmail.shakeBox = "email-shake";
                        setTimeout(() => {
                            this.$refs.tabEmail.shakeBox = "box-shakeOrigin";
                        }, 200);
                        return;
                    }
                    this.$parent.sendEmail = this.$refs.tabEmail.email;
                }
                this.addEmailNoticeShow = false;
            },
            open(email) {
                if(email) {
                   this.$refs.tabEmail.email = email;
                    // this.task = null;
                }
                this.addEmailNoticeShow = true;
            },
        }
    }
</script>

<style scoped>
#addEmailNoticeBox {
    width: 600px;
    /*no*/
    height: 260px;
    /*no*/
}

#addEmailNoticeBox .emial-notice-content {
    box-sizing: border-box;
    padding: 30px 20px;
    /*no*/
}

#addEmailNoticeBox .emial-notice-input {
    display: flex;
    align-items: center;
}

#addEmailNoticeBox .emial-notice-footer {
    position: absolute;
    right: 20px;
    /*no*/
    bottom: 20px;
    /*no*/
}

.send-email {
    width: 340px;
    /*no*/
    height: 32px;
    /*no*/
    float: left;
    margin-top: 0px;
    /*no*/
}

.send-letter {
    float: left;
    height: 30px;
    /*no*/
    margin-top: 0px;
    /*no*/
    margin-left: 10px;
    /*no*/
    white-space: nowrap;
}

#addEmailNoticeBox >>> .check-item-position {
    position: relative;
    top: -1px;/*no*/
    left: 5px;/*no*/
    line-height: 15Px;/*no*/
    white-space: pre-wrap;
    font-size: 14px;/*no*/
    color: #6f7886;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/add_email_notice_popup.vue